import React, { useMemo } from 'react';
import TrendChartCard from './_components/TrendChartCard';
import { getTitle } from './_utils/common';
import { useIntl } from 'umi';
import { TrendChartDataConfig } from './_config/types';
import { dynamicString } from '@home/utils/dynamicString';

interface TrendChartCoProps {
  data: {
    dataBy: string;
    gameCode: string;
    [key: string]: any;
  };
  index: number;
  refArray?: React.RefObject<HTMLDivElement>[];
  style?: any;
  config: TrendChartDataConfig;
  showDodSdlw?: boolean;
}

const TrendChartCo: React.FC<TrendChartCoProps> = (props) => {
  const {
    data,
    index,
    refArray,
    style,
    config,
    showDodSdlw
  } = props;

  const { dataBy, gameCode } = data || {};
  const { locale, formatMessage } = useIntl();

  const { title: titleEn, titleCn, formatTitle, dataKey } = config || {};
  const title = useMemo(
    () => getTitle(dynamicString(titleEn, data), dynamicString(titleCn, data), formatTitle, locale, formatMessage),
    [titleEn, titleCn, formatTitle, data, locale, formatMessage]
  );

  const metricsData = {
    componentData: data[dataKey]?.data || {},
    isError: !!data[dataKey]?.errorMsg || false,
    isLoading: data[dataKey]?.loading || false,
    ...data
  };

  return (
    <>
      <div
        ref={refArray?.[index]}
        id={String((index || 0) + 1)}
        style={style}
      >
        <TrendChartCard
          title={title}
          gameCode={gameCode}
          data={metricsData}
          dataBy={dataBy}
          componentMetric={config}
          height={config?.height}
          showDodSdlw={showDodSdlw}
        />
      </div>
    </>
  );
};

export default TrendChartCo;